import { create } from 'zustand';

type DefaultIframe =
  | {
      type: 'default';
      src: string;
      title: string;
    }
  | {
      type: 'withSubmit';
      src: string;
      title: string;
      onSubmit: () => void;
      submitTitle: string;
    }
  | null;

type PassportModal = {
  code: string;
} | null;

interface IVDLModalStore {
  defaultIframe: DefaultIframe;
  setDefaultIframe: (defaultIframe: DefaultIframe) => void;

  passportModal: PassportModal;
  setPassportModal: (passportModal: PassportModal) => void;
}

export const useVDLModalStore = create<IVDLModalStore>((set) => ({
  defaultIframe: null,
  setDefaultIframe: (defaultIframe) => set({ defaultIframe }),

  passportModal: null,
  setPassportModal: (passportModal) => set({ passportModal })
}));
